import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {IExgTab} from 'exc-tab-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExgTabV2ComponentHeaderElement} from '../../../misc/exg-tab-v2/exg-tab-v2.component';
import {ExcRestService} from 'exc-rest-v2';
import {DomSanitizer} from '@angular/platform-browser';
import {ExcSecurityService} from 'exc-security-v2';
import {EnumerationService} from '../../../services/enumeration.service';
import {ApplicationService} from '../../../services/application.service';
import {isNumeric} from 'rxjs/internal-compatibility';
import {Editor} from 'tinymce';
import {ITaskSummaryData} from '../../../misc/interfaces/ITaskSummaryData';
import {DataService} from '../../../services/data.service';
import {ExgApplicationEventEmitter} from '../../../misc/classes/ExgApplicationEventEmitter';
import {MessageDataService} from '../../../services/message-data.service';
import {ICaseSummaryData} from '../../../misc/interfaces/ICaseSummaryData';

@Component({
  selector: 'app-tab-message-read',
  templateUrl: './tab-message-read.component.html',
})
export class TabMessageReadComponent extends ExcTranslation implements OnInit, IExgTab, OnDestroy {

  Events: ExgApplicationEventEmitter = new ExgApplicationEventEmitter();
  rightTabs: ExgTabV2ComponentHeaderElement[] = [];

  TaskSummary: ITaskSummaryData = this.dataSvc.Task.Summary.Get();
  CaseSummary: ICaseSummaryData = this.dataSvc.Case.Summary.Get();

  Data: undefined | { msgID: string, fkID: string, Events?: ExgApplicationEventEmitter};
  tabinstance: any;
  userType: number | any;
  rightDrawerVisible = false;
  ready = false;
  showCC = true;

  MCEinitDisabled: any = {
    placeholder: '',
    formats: {
      bold: [{inline: 'span', styles: {fontWeight: 'bold'}}],
      italic: [{inline: 'span', styles: {fontStyle: 'italic'}}]
    },
    base_url: './tinymce',
    suffix: '.min',
    inline: false,
    height: '100%',
    resize: false,
    menubar: false,
    statusbar: false,
    plugins: [],
    toolbar: '',
    contextmenu: '',
    setup: (editor: Editor) => {

    }
  };

  get _allowReadMode(): boolean {
    return this.excSecurity.isFeatured('MSGREAD');
  }

  Message: any;
  MessageHtml: any;
  MessageReceipients = {
    msgEmpfaengerTo: [] as any[],
    msgEmpfaengerCc: [] as any[]
  };
  MessageAttachments = {
    selectKey: 'dokID',
    state: 1,
    data: [] as any[],
    selected: [] as any[],
    selectedObjects: [] as any[],
    ready: (length: number) => {
      if (!this.MessageAttachments.data || length === 0) {
        this.MessageAttachments.state = 2;
      } else {
        this.MessageAttachments.state = 0;
      }
    },
    loadData: (data: any[]) => {
      // @ts-ignore
      this.MessageAttachments.data = data;
      this.MessageAttachments.ready(this.MessageAttachments.data.length);
    },
    RowDblClick: (selectedIndex: number) => {
      this.showAttachmentPreview(this.MessageAttachments.data[selectedIndex].dokID);
    }
  };
  to: any;
  LinkedTasks = {
    data: [] as any[],
    loadData: (data: any[]): void => {
      this.LinkedTasks.data = data;
      if (data && data.length === 1) {
        this.TaskSummary = this.dataSvc.Task.Summary.Get(data[0].vorgID, undefined, {Events: this.Events});
      }
    }
  };
  LinkedCases = {
    data: [] as any[],
    loadData: (data: any[]): void => {
      this.LinkedCases.data = data;
      if (data && data.length === 1) {
        this.CaseSummary = this.dataSvc.Case.Summary.Get(data[0].auID, undefined, {Events: this.Events});
      }
    }
  };


  constructor(public excRestService: ExcRestService,
              private cdr: ChangeDetectorRef,
              public enumSvc: EnumerationService,
              public sanitizer: DomSanitizer,
              public modalService: ExgModalService,
              public excSecurity: ExcSecurityService,
              private modal: ExgModalService,
              private dataSvc: DataService,
              private msgDataSvc: MessageDataService,
              public appSvc: ApplicationService) {
    super();
    this.initialize();
  }

  ngOnDestroy(): void {
    if (this.to)
    {
      clearTimeout(this.to);
      this.to = undefined;
    }
  }

  initialize(): void {
    const SELF = this;
    SELF.userType = Number(this.appSvc.UserAttributes()?.type) || 2;
    SELF.Message = {
      msgID: ExcCoreModule.Guid.NewGuid(),
      msg_objID: undefined,
      msg_enmIdent_NachrichtTyp: this.enumSvc.getEnumerationDefaultValue('NachrichtTyp'),
      msg_enmIdent_NachrichtPrio: this.enumSvc.getEnumerationDefaultValue('NachrichtPrio'),
      msg_enmIdent_Postfach: this.enumSvc.getEnumerationDefaultValue('Postfach'),
      msgNachrichtKategorie_enmIdent: this.enumSvc.getEnumerationDefaultValue('NachrichtKategorie'),
      msgAbsender: undefined,
      msgBetreff: '',
      msgText: '',
      msgFIN: false

    };
    SELF.rightTabs = [{
      get caption(): string {
        return SELF.getResource('Tabs.Case.HeaderText');
      },
      get icon_class(): string {
        return SELF.getResource('Tabs.Case.Icon');
      }
    }];
  }

  ngOnInit(): void {
    if (this.Data?.Events) {
      this.Events = this.Data.Events;
    }
    if (!this._allowReadMode) {
      return;
    }
    this.loadMessageData();
  }

  loadMessageData(): void {
    this.excRestService.get(this.excRestService.computeUrl('MessageR_Summary', {msgID: this.Data?.msgID})).subscribe(
      (response: any) => {
        if (!response.success) {
          return;
        }

        this.Message = response.data.Message;
        this.MessageHtml = this.sanitizer.bypassSecurityTrustHtml(this.Message.msgText);
        this.tabinstance.Label = this.Message.msgBetreff;

        this.MessageReceipients.msgEmpfaengerTo =
          response.data.Receipients.filter((e: any) => e.empf_enmIdent_NachrichtEmpfaengerTyp === 1);
        this.MessageReceipients.msgEmpfaengerCc =
          response.data.Receipients.filter((e: any) => e.empf_enmIdent_NachrichtEmpfaengerTyp === 2);

        this.MessageAttachments.loadData(response.data.Attachments);
        this.LinkedTasks.loadData(response.data.LinkedTasks);
        this.LinkedCases.loadData(response.data.LinkedCases);
        this.to = setTimeout(() => {
          this.msgDataSvc.Message.SetRead(this.Message.msgID).subscribe();
        }, 5000);
      }
    );
  }

  changeMessageCategory($event: { index: number; value: any }): void {
    this.Message.msgNachrichtKategorie_enmIdent = $event.value.enmIdent;
    this.msgDataSvc.Message.UpdateCategory(this.Message.msgID, this.Message.msgNachrichtKategorie_enmIdent).subscribe(response => {
      if (response && response.success && response.data) {
        this.Message.msgNachrichtKategorie_enmIdent = response.data.Message.msgNachrichtKategorie_enmIdent;
      }
    });
  }

  close(): void {
    this.tabinstance.Close();
  }

  showAttachmentPreview(dokID?: string): void {
    if (dokID) {
      const otherAttachment = this.MessageAttachments.data.find(att => att.dokID === dokID);
      this.modal.show('ModalImageViewerComponent', {
        objID: this.Message.msgID,
        attID: dokID,
        otherMime: [otherAttachment]
      }).subscribe((rtVal: any) => {
      });
    } else {
      this.modal.show('ModalImageViewerComponent',
        {
        objID: this.Message.msgID,
        otherMime: this.MessageAttachments.data
      }).subscribe((rtVal: any) => {
      });
    }
  }

  openCase(evt: number): void {

  }

  openTask(evt: number | string): void {
    if (isNumeric(evt)) {
      this.appSvc.Task.Workspace.OpenTabV2(this.LinkedTasks.data[evt as number].vorgID);
    } else {
      this.appSvc.Task.Workspace.OpenTabV2(evt);
    }
  }

  openReply(): void {
    this.appSvc.Message.AnswerForward.OpenTab({
      Mode: 'answer',
      Message: this.Message,
      MessageRecipients: this.MessageReceipients,
      MessageAttachments: this.MessageAttachments.data,
      LinkedTasks: this.LinkedTasks.data,
      LinkedCases: this.LinkedCases.data,
      SelectedFkID: this.Data?.fkID
    });
  }

  openForward(): void {
    this.appSvc.Message.AnswerForward.OpenTab({
      Mode: 'forward',
      Message: this.Message,
      MessageRecipients: this.MessageReceipients,
      MessageAttachments: this.MessageAttachments.data,
      LinkedTasks: this.LinkedTasks.data,
      LinkedCases: this.LinkedCases.data,
      SelectedFkID: this.Data?.fkID
    });
  }

  createNewTask(): void {
    if (this.LinkedCases.data.length === 1 && this.Message.msg_enmIdent_NachrichtTyp === 2) {
      this.appSvc.Case.NewTask.OpenTab(
        {
          auID: this.CaseSummary?.ID,
          linkedID: this.Message.msgID
        },
        {Events: this.Events}
      );
    }
  }

  setDone($event: any): void {
    this.Message.msgFIN = $event;
    this.msgDataSvc.Message.UpdateDone(this.Message.msgID, this.Message.msgFIN).subscribe(response => {
      if (response && response.success && response.data) {
        this.Message.msgFIN = response.data.Message.msgFIN;
        this.Message.msgFID = response.data.Message.msgFID;
        this.Message.msgFIU = response.data.Message.msgFIU;
      }
    });
  }

  createNewCase(): void {
    this.appSvc.Case.NewCase.OpenTab(
      {
        auID: '',
        wert1914Faktor: 0,
        auNr: '',
        linkedID: this.Message.msgID
      }, {Events: this.Events});
  }

  openLinkCase(): void {
    this.modalService.show('ModalSelectCaseComponent', this.LinkedCases.data, true)
      .subscribe((retValue: any) => {
        if (retValue && retValue.length > 0) {
          const dataObject = {
            selectedLinkTos: [] as any[],
          };

          for (const retValueElement of retValue) {
            dataObject.selectedLinkTos.push({refID: retValueElement});
          }

          this.excRestService.post(
            this.excRestService.computeUrl('MessageLinkCUD', {msgID: this.Message.msgID, lnkType: 0} )
            , dataObject
          ).subscribe((returnValue: any) => {
            if (returnValue && returnValue.success) {
              this.loadMessageData();
              this.modal.showToast('Verlinkung geändert', 'md-toast', 'far fa-link');
              this.Events?.Message?.Reader?.LinkChanged.emit();
            }
          });
        }
    });
  }

  openLinkTask(): void {
    this.modalService.show('ModalSelectTaskComponent', this.LinkedTasks.data, true)
      .subscribe((retValue: any) => {
        if (retValue && retValue.length > 0) {
          const dataObject = {
            selectedLinkTos: [] as any[],
          };

          for (const retValueElement of retValue) {
            dataObject.selectedLinkTos.push({refID: retValueElement});
          }

          this.excRestService.post(
            this.excRestService.computeUrl('MessageLinkCUD', {msgID: this.Message.msgID, lnkType: 1}, )
            , dataObject
          ).subscribe((returnValue: any) => {
            if (returnValue && returnValue.success) {
              this.loadMessageData();
              this.modal.showToast('Verlinkung geändert', 'md-toast', 'far fa-link');
              this.Events?.Message?.Reader?.LinkChanged.emit();
            }
          });
        }
      });
  }

  unLink(linkedObject: any, lnkType = 0): void {
    const dataObject = {
      selectedLinkTos: [] as any[],
    };

    this.modalService.showSimple(
        this.getRessource('Unlink.Header')
        , this.getRessource('Unlink.Text', {objNr: linkedObject.auID ? linkedObject.auNr : linkedObject.vorgNr})
        , true
        , true
        , this.getRessource('Unlink.DoUnlink')
        , this.getGlobal('Cancel')
      ).subscribe((value: boolean) => {
        if (value) {
          if (lnkType === 0) {
            for (const caseElement of this.LinkedCases.data) {
              if (caseElement.auID !== linkedObject.auID) {
                dataObject.selectedLinkTos.push({refID: caseElement.auID});
              }
            }
          } else if (lnkType === 1) {
            for (const taskElement of this.LinkedTasks.data) {
              if (taskElement.vorgID !== linkedObject.vorgID) {
                dataObject.selectedLinkTos.push({refID: taskElement.vorgID});
              }
            }
          } else {
            return;
          }

          this.excRestService.post(
            this.excRestService.computeUrl('MessageLinkCUD', {msgID: this.Message.msgID, lnkType}, )
            , dataObject
          ).subscribe((returnValue: any) => {
            if (returnValue && returnValue.success) {
              this.loadMessageData();
              this.modal.showToast('Verlinkung entfernt', 'md-toast', 'far fa-unlink');
              this.Events?.Message?.Reader?.LinkChanged.emit();
            }
          });
        }
      });

  }
}
